// extracted by mini-css-extract-plugin
export default {"incutWrapper":"wiBXX_Wu","mobile":"mobile"};